import { Modal, Spinner, SpinnerSize } from '@fluentui/react';
import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import { _getClippedKeyImageForPreview } from '../../../../service/StudyViewerService';
import studyReportContext from "../../../../context/studyreport/StudyReportContext";


const ManageClippedKeyImagePreview = (props) => {

  const [imageError, setImageError] = useState(false);
  const [imageErrorMsg, setImageErrorMsg] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [loading, setLoading] = useState(false);
  const { previewClippedKeyImageBase64} = useContext(studyReportContext);

  const Containerstyles=  {
    root:{
      backgroundColor: 'rgb(22, 21, 20, 0.7)'
   },
    main:{
      boxSizing: "border-box",
      borderRadius: "10px 10px 10px 10px",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
      border: "1px solid #4B4B4B",
    },
  }

  const { t } = useTranslation();

  useEffect(()=>{
   // previewClippedKeyImageFunc();
     console.log(previewClippedKeyImageBase64)
    setImageURL("data:image/jpeg;base64, "+previewClippedKeyImageBase64);
  },[]);


  const previewClippedKeyImageFunc = async() =>{
    let studyId = props.studyId;
    let imageId = props.imageId;
    setLoading(true);
    try{
      const response = await _getClippedKeyImageForPreview(studyId, imageId);
      console.log(response);
      const contentType = response.headers.get('Content-Type');
        if (response.status===200) {
          console.log('image found');
          setImageURL("data:image/jpeg;base64, "+response.data.data);
          setImageErrorMsg("");
          setImageError(false);
          console.log("image url", imageURL);
        }else{
          setImageError(true);
          setImageErrorMsg("No image found");
        }
        setLoading(false);
    }catch(error){
      setImageErrorMsg("Unknown error occurred while retrieving image.");
      setLoading(false);
      setImageError(true);
    }
  }


    return (
      <>
          <Modal
            isOpen={props.previewClippedKeyImage}
            titleAriaId="id"
            scrollableContentClassName={"stop-scroll-for-modal"}
            styles={Containerstyles}
          >
            <div style={{width:"500px"}}>
              <ModalHeader
                handleCancel={() => props.setPreviewClippedKeyImage(false)}
                updatedModal = {true}
                heading = "Preview Image"
              />
              {loading ? (
              <div
                style={{
                  padding: "auto",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  margin:"20px"
                }}
              >
                <Spinner size={SpinnerSize.large} />
                </div>
              ) :
                <div style={{margin:"15px 0px 20px 0px"}}>
                  {imageError === false ?
                    <img src={imageURL} id="previewKeyImage_" alt="_keyImage" style={{width:"100%"}}/> : <span style={{color:"white"}}>{imageErrorMsg}</span>
                  }
                </div>
              }
              <ModalFooter
                DefaultButtonList={[
                      {
                      title: t("key-image.cancel"),
                      onclick: () => props.setPreviewClippedKeyImage(false),
                      },
                  ]}
              />
            </div>
          </Modal>
        </>
      );
}

export default ManageClippedKeyImagePreview